
import { defineComponent } from 'vue';
import { Actions, Getters, userSettingsStore } from '@/store';
import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import utils from '@/utils/QSUtils';
import UserSettingsManager from '@/manager/UserSettingsManager';
import { newRunFieldPrefsRequest } from '@/store/3.6/models/RunFieldPrefsRequest';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    data(): { modal: { hide: () => void } | null } {
        return {
            modal: null,
        };
    },
    setup() {
        const store = useStore();

        return {
            store,
        };
    },
    computed: {
        subjectCascadeDisabled(): boolean {
            return UserSettingsManager.isSubjectCascadeDisabled() ?? true;
        },
    },
    mounted() {
        const modalElement = this.$refs.subjectRunDataPreferences;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        async save() {
            const selectedRadio = document.querySelector('input[name="cascadeLock"]:checked') as HTMLInputElement;
            const subjectCascadeDisabled = utils.stringToBoolean(selectedRadio.value);

            await userSettingsStore.setSubjectCascadeDisabled({
                SubjectCascadeDisabled: subjectCascadeDisabled
            });

            if (!subjectCascadeDisabled) {
                const activeComp = this.store.getters[Getters.CompAddressesV36.ActiveComp];
                if (activeComp?.isSubject) {
                    await this.store.dispatch(
                        Actions.CompAddressesV36.TransferRunAllFieldDataPreferences,
                        newRunFieldPrefsRequest(activeComp)
                    );
                    await this.store.dispatch(Actions.CompAddressesV36.TransferValueTranslations, activeComp);
                }
            }

            ModalService.hide(this.modal);
        },
    },
});
